import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
// material

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Moment from 'moment';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { format } from "date-fns";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AccordionDetails, Select, TextareaAutosize, Autocomplete, Stack, Grid, Divider, TextField, FormControl, FormGroup, InputLabel, FormControlLabel, Checkbox, Modal, IconButton, Typography, Tooltip, MenuItem, Button, Box, Menu, Tabs, Tab, FormHelperText, FormLabel, Card, ListItemText, ListItemIcon, Chip } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import {
    LoadingButton,
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
} from '@mui/lab';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ListIcon from '@mui/icons-material/List';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
// import IssueAllocationServicePage from '../../SidebarMenuComponents/ServiceComponent/IssueAllocationServicePage'
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';
import ApplyForLeave from '../LeaveComponent/ApplyForLeave';

// -----------------------------------------------------------------------------------------------------
const viewStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fbe9e7', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));
const TextAccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#FFF', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function LeaveHistory({ fromDate, handleFromDate, toDate, handleToDate, leaveType, selectedLeaveType, handleLeaveType, handleFilterLeaveHistory, handleLeaveHistoryReset, viewLeaveHistoryModal, handleViewLeaveHistoryCloseModal, historyColumns, historyRows, viewLeaveHistoryData, cancelModal, handleCancelConfirm, handleCancelClick, editModalOpen, setEditModalOpen, setEditModalData, editModalData, pastLeaveColumns, upcomingLeaveColumns, leaveTypeRadio, handleLeaveTypeRadio, formattedDate, formattedDay, handleDeleteDate, teamImpactColumns, selectedImpactDate, date, handleDate, remark, handleRemark, handleApplyForLeave, }) {

    return (
        <Box sx={{ p: 2 }}>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                        label="From Date"
                        inputFormat="dd/MM/yyyy"
                        value={Moment(fromDate, 'DD-MMM-YYYY').toDate()}
                        onChange={handleFromDate}
                        renderInput={(params) => <TextField size="small" {...params} sx={{ width: 180 }} error={false} />}
                    />
                    <DesktopDatePicker
                        label="To Date"
                        inputFormat="dd/MM/yyyy"
                        value={Moment(toDate, 'DD-MMM-YYYY').toDate()}
                        onChange={handleToDate}
                        renderInput={(params) => <TextField size="small" {...params} sx={{ width: 180 }} error={false} />}
                    />
                </LocalizationProvider>
                <FormControl size="small" fullWidth sx={{ width: 180 }}>
                    <Autocomplete
                        fullWidth
                        size="small"
                        id="leaveHistory"
                        value={selectedLeaveType.find((option) => option.id === leaveType) || ""}
                        onChange={(_, newValue) => handleLeaveType(newValue)}
                        options={selectedLeaveType}
                        getOptionLabel={(option) => option.Name || ""}
                        renderInput={(params) => <TextField {...params}
                            placeholder="Select Leave Type" label="Leave Type" />}
                        limitTags={2}
                    />

                </FormControl>
                <Tooltip title="Filter">
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleFilterLeaveHistory}
                        sx={{ minWidth: 40, }}

                    >
                        <Icon icon="material-symbols:search" width="20" height="20" sx={{ mr: '3px' }} />
                    </Button>
                </Tooltip>

                {/* Reset */}
                <Tooltip title="Reset">
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleLeaveHistoryReset}
                        sx={{ minWidth: 40, }}

                    >
                        <Icon icon="ic:twotone-restart-alt" width="20" height="20" />
                    </Button>
                </Tooltip>
            </Stack>
            <Modal open={viewLeaveHistoryModal} onClose={handleViewLeaveHistoryCloseModal}>
                <Box sx={viewStyle}>
                    {/* Header */}
                    <Box
                        sx={{
                            borderBottom: '1px solid #D1D5DB',
                            px: 2,
                            py: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Typography variant="h6" fontWeight={600}>
                            Leave Request
                        </Typography>
                        <IconButton size="small" onClick={handleViewLeaveHistoryCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Body */}
                    <Box sx={{ p: 2 }}>
                        {viewLeaveHistoryData && (
                            <Stack spacing={1.5}>

                                {/* Status */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Status</Typography>
                                    <Chip
                                        label={viewLeaveHistoryData.status}
                                        size="small"
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: 12,
                                            bgcolor:
                                                viewLeaveHistoryData.status === 'Approved'
                                                    ? '#E5F5EB'
                                                    : viewLeaveHistoryData.status === 'Pending'
                                                        ? '#FEF9C2'
                                                        : '#FAE3E6',
                                            color:
                                                viewLeaveHistoryData.status === 'Approved'
                                                    ? '#00A63E'
                                                    : viewLeaveHistoryData.status === 'Pending'
                                                        ? '#894B00'
                                                        : '#D93A46',
                                        }}
                                    />
                                </Box>

                                {/* Applied Date */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Applied Date</Typography>
                                    <Typography fontWeight={500}>
                                        {viewLeaveHistoryData.appliedDate}
                                    </Typography>
                                </Box>

                                {/* Leave Type */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Leave Type</Typography>
                                    <Typography fontWeight={500}>
                                        {viewLeaveHistoryData.leaveType}
                                    </Typography>
                                </Box>

                                {/* Leave Date */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Leave Date</Typography>
                                    <Typography fontWeight={500}>
                                        {viewLeaveHistoryData.dates}
                                    </Typography>
                                </Box>

                                {/* Remark */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary"> Remark</Typography>
                                    <Typography fontWeight={500}>
                                        {viewLeaveHistoryData.remark}
                                    </Typography>
                                </Box>

                            </Stack>
                        )}
                    </Box>
                </Box>
            </Modal>
            {cancelModal && (
                <Modal open={cancelModal} onClose={handleCancelClick}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 380,
                            bgcolor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "none",
                            p: 2,
                        }}
                    >
                        {/* MESSAGE */}
                        <Typography fontSize="14px" fontWeight="600">
                            Are you sure you want to cancel the leave request ?
                        </Typography>

                        {/* ACTIONS */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: 2,
                                mt: 3,
                            }}
                        >
                            {/* NO */}
                            <Typography
                                onClick={handleCancelClick}
                                sx={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    fontWeight: 600,
                                    color: "#000",
                                    fontSize: '14px'
                                }}
                            >
                                No
                            </Typography>

                            {/* YES */}
                            <Button
                                variant="contained"
                                onClick={handleCancelConfirm}
                                sx={{
                                    backgroundColor: "#FF2B2B",
                                    borderRadius: "8px",
                                    px: 3,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": {
                                        backgroundColor: "#FF2B2B",
                                    },
                                    fontSize: '14px'

                                }}
                            >
                                Yes
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            )}
            <Modal
                open={editModalOpen}
                onClose={() => setEditModalOpen(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: '100%',
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow: 24,
                        maxHeight: "90vh",
                        overflowY: "auto",
                        p: 2
                    }}
                >
                    {/* Modal Header */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={600}>
                            Apply for Leave
                        </Typography>
                        <IconButton size="small" onClick={() => setEditModalOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Apply Form */}
                    <ApplyForLeave
                        date={editModalData?.dates || []}
                        handleDate={(d) =>
                            setEditModalData(prev => ({ ...prev, dates: d }))
                        }
                        remark={editModalData?.remark || ""}
                        handleRemark={(e) =>
                            setEditModalData(prev => ({ ...prev, remark: e.target.value }))
                        }
                        pastLeaveColumns={pastLeaveColumns}
                        upcomingLeaveColumns={upcomingLeaveColumns}
                        handleApplyForLeave={() => {
                            console.log("Updated leave data", editModalData);
                            // call your API to update leave
                            setEditModalOpen(false);
                        }}
                        leaveTypeRadio={{}}
                        handleLeaveTypeRadio={() => { }}
                        handleDeleteDate={(index) => {
                            const newDates = [...editModalData.dates];
                            newDates.splice(index, 1);
                            setEditModalData(prev => ({ ...prev, dates: newDates }));
                        }}
                        teamImpactColumns={teamImpactColumns}
                    />
                </Box>
            </Modal>
            {/* DataGrid for History */}
            <Box sx={{ height: '56vh', width: '100%', }}>
                <DataGrid rows={historyRows} columns={historyColumns} density="compact" getRowId={(row) => row.id} />
            </Box>
        </Box>
    );
}